"use client"

interface LogPayload {
  level: "error" | "warn" | "info" | "security"
  source: string
  message: string
  stack?: string
  url?: string
  extra?: Record<string, unknown>
}

/**
 * Envoyer une erreur client au serveur.
 * Fire and forget — ne bloque jamais l'UX.
 * Utilise sendBeacon (survit a la fermeture de page).
 */
export function logError(payload: LogPayload) {
  try {
    const body = JSON.stringify({
      ...payload,
      url: payload.url ?? (typeof window !== "undefined" ? window.location.pathname : undefined),
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    })

    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon("/api/log", new Blob([body], { type: "application/json" }))
    } else if (typeof fetch !== "undefined") {
      fetch("/api/log", { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {})
    }
  } catch {
    // Silencieux — le logging ne doit jamais causer d'erreur
  }
}
